<template>
  <div class="staff-list">
    <div class="top-box clearfix">
      <p class="fl big-title">员工列表</p>
      <div class="fr">
        <el-button
          size="large"
          type="primary"
          clstag="pageclick|keycount|staff_list|createStaff"
          @click="createNew"
        >
          新建员工
        </el-button>
        <el-button
          size="large"
          type="primary"
          clstag="pageclick|keycount|staff_quickBindList|addBind"
          @click="addQuickBind"
        >
          批量资产分配
        </el-button>
      </div>
    </div>
    <div class="staff-container">
      <div class="staff-department-tree">
        <div class="staff-department-tree-header">
          <p class="staff-department-tree-title">部门组织架构</p>
          <el-button type="text" @click="$router.push({ name: 'department' })">编辑</el-button>
        </div>
        <el-tree
          ref="tree"
          :data="departmentTree"
          :props="{
            label: 'deptName',
          }"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="treeDefaultExpendedKeys"
          node-key="deptId"
          pane
          @node-click="handleDepartClick"
        >
          <span slot-scope="{ data }" class="el-tree-node__label">
            {{ `${data.deptName} (${data.employeeNum})` }}
          </span>
        </el-tree>
      </div>
      <div class="staff-list-body">
        <!-- 查找 -->
        <el-form
          ref="assetListFrom"
          label-position="right"
          :inline="true"
          :model="searchForm"
          class="search-list"
        >
          <el-form-item
            label="员工姓名"
            label-width="82px"
            class="search-item"
          >
            <el-input
              v-model.trim="searchForm.name"
              placeholder="请输入"
              class="w238"
              clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item label="员工状态" label-width="92px" class="search-item">
            <el-select v-model="searchForm.status" class="w238" placeholder="全部">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
                clearable
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="手机号"
            label-width="82px"
            class="search-item"
          >
            <el-input
              v-model.trim="searchForm.phone"
              placeholder="请输入"
              class="w238"
              clearable
              :maxlength="11"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            label="员工角色"
            label-width="92px"
            class="search-item"
          >
            <el-select v-model="searchForm.roleId" class="w238" placeholder="全部">
              <el-option
                v-for="(item, index) in roleList"
                :key="index"
                :label="item.roleName"
                :value="item.roleId"
                clearable
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="search-btn-box">
          <el-button
            class="btn search-btn"
            functional
            clstag="pageclick|keycount|staff_list|search"
            @click="search"
          >
            查询
          </el-button>
          <el-button class="btn reset-btn" plain clstag="pageclick|keycount|staff_list|reset" @click="reset()">重置</el-button>
        </div>

        <!-- 员工列表 -->
        <el-table
          v-loading="loading"
          :data="list"
          border
          tooltip-effect="dark"
          :empty-text="emptyText"
          class="list-table"
          :resizable="false"
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            width="60"
            fixed
          >
            <template slot-scope="scope">{{ Number(scope.$index + 1) + (pageNum - 1) * 10 }}</template>
          </el-table-column>
          <el-table-column label="员工姓名" width="110" prop="name" fixed>
            <!-- <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row.employeeId)">{{ scope.row.name }}</el-button>
            </template> -->
          </el-table-column>
          <el-table-column label="手机号" width="110" prop="phone" >
          </el-table-column>
          <el-table-column label="员工性别" width="80" prop="gender" >
            <template slot-scope="scope">
              {{ scope.row.gender | formateGender }}
            </template>
          </el-table-column>
          <el-table-column label="员工状态" width="90" prop="status" >
            <template slot-scope="scope">
              <span :class="{red: [0,1].includes(Number(scope.row.status))}">{{ scope.row.status | formateStatus }}</span>
              <el-tooltip v-if="Number(scope.row.status) === 1" class="item" effect="dark" content="员工尚未加入企业中心，请邀请或提示员工按照短信提示进行激活" placement="top">
                <i class="el-icon-question-outline status-icon"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="员工部门" prop="departmentItemList" width="200">
            <template slot-scope="scope">
              {{ scope.row.departmentItemList | formatDepartment }}
            </template>
          </el-table-column>
          <el-table-column label="员工角色" prop="roleName">
            <template slot-scope="scope">
              {{ scope.row.roleName || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="分配资产" prop="assetCount" width="90" >
            <template slot-scope="scope">
              <span>{{ !scope.row.assetCount ? '0' : scope.row.assetCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="163">
            <template slot-scope="scope">
              <!-- 未激活 - 邀请  -->
              <el-button
                v-if="Number(scope.row.status) === 1"
                type="text"
                class="unbind-btn"
                clstag="pageclick|keycount|staff_list|op_invite"
                :disabled="(typeof scope.row.countTimer !== 'undefined' && scope.row.countTimer > 0)"
                @click="invite(scope.row, scope.$index)"
              >
                <span>邀请<label v-if="typeof scope.row.countTimer !== 'undefined' && scope.row.countTimer > 0">({{ scope.row.countTimer }}s)</label></span>
              </el-button>
              <el-button
                v-if="Number(scope.row.status) === 2"
                type="text"
                class="unbind-btn"
                clstag="pageclick|keycount|staff_list|op_bind"
                @click="bind(scope.row.employeeId)"
              >
                资产分配
              </el-button>
              <el-button
                v-if="scope.row.employeeType !== 1"
                type="text"
                class="unbind-btn"
                :clstag="`pageclick|keycount|staff_manage__36|${scope.row.roleName || '-'}`"
                @click="bindAuth(scope.row.employeeId)"
              >
                角色设置
              </el-button>
              <el-button
                v-if="Number(scope.row.status) !== 0 && Number(scope.row.employeeType) !== 1"
                type="text"
                class="unbind-btn"
                clstag="pageclick|keycount|staff_list|op_modifyInfo"
                @click="editor(scope.row)"
              >
                修改
              </el-button>
              <el-button
                v-else
                type="text"
                class="unbind-btn"
                clstag="pageclick|keycount|staff_list|lookInfo"
                @click="editor(scope.row, false)"
              >
                查看
              </el-button>
              <!-- 已停用 -->
              <el-button
                v-if="Number(scope.row.status) !== 0 && Number(scope.row.employeeType) !== 1"
                type="text"
                class="bind-btn"
                clstag="pageclick|keycount|staff_list|op_remove"
                @click="remove(scope.row)"
              >
                离职
              </el-button>
              <!--启用（已停用） -->
              <el-button
                v-if="Number(scope.row.status) === 0 && Number(scope.row.employeeType) !== 1"
                type="text"
                class="bind-btn"
                clstag="pageclick|keycount|staff_list|op_add"
                @click="enable(scope.row)"
              >
                入职
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          :current-page="pageNum"
          :page-sizes="[10, 20]"
          :page-size="pageSize"
          class="fr"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
          @size-change="changePageSize"
          @current-change="changeCurrentPage"
        >
        </el-pagination>

        <!-- 新建员工 -->
        <CreateStaff
          v-if="isCreate"
          :visible="isCreate"
          :employee-id="editorEmployeeId"
          :can-editor="canEditor"
          :departments="departments"
          :departments-arr="departmentsArr"
          @closeCreate="closeCreate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  employeeList, employeeDelete, employeeEnable, employeeInvite, employeeInfo,
} from '@/api/apis/staff';
import { getAllRole } from '@/api/apis/role';
import { getDepartList } from '@/api/apis/depart';
import { clstagA } from '@/utils/index';
import { treeBuild } from '@/utils/tree';
import CreateStaff from './components/createStaff.vue';

export default {
  name: 'List',
  components: {
    CreateStaff,
  },
  filters: {
    formateStatus(status) {
      const list = {
        1: '未激活',
        2: '已激活',
        0: '离职',
      };

      if (String(status)) {
        return list[String(status)];
      }
      return '--';
    },
    formateGender(genter) {
      const list = {
        1: '男',
        0: '女',
      };

      if (typeof genter !== 'undefined') {
        return list[Number(genter)];
      }
      return '--';
    },
    formatDepartment(departmentList) {
      if (departmentList && departmentList.length > 0) {
        const cp = departmentList.slice(0);
        return cp.sort((a, b) => a.level - b.level).map((item) => item.deptName).join(' / ');
      }

      return '--';
    },
  },
  data() {
    return {
      emptyText: '暂无员工数据，请点击右上角创建员工',
      departmentTree: [], // 将部门树和公司名、未分配部门混合成一颗新的树
      departments: [], // 部门树
      departmentsArr: [], // 部门数组（后端直接传回的拍平的数组）
      treeDefaultExpendedKeys: [], // el-tree 组件默认展开节点
      currentDeptId: '', // 当前选中的部门 Id
      isCreate: false,
      editorEmployeeId: null, // 编辑的员工id
      canEditor: true, // 是否可编辑
      searchForm: {
        name: '',
        gender: null,
        email: '',
        phone: '',
        status: null,
        roleId: null,
        createTime: '',
      },
      sexList: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '男',
          value: 1,
        },
        {
          label: '女',
          value: 0,
        },
      ],
      statusList: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '未激活',
          value: 1,
        },
        {
          label: '已激活',
          value: 2,
        },
        {
          label: '离职',
          value: 0,
        },
      ],
      roleList: [],
      list: [],
      company: {},
      loading: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      timeOptions: {
        disabledDate: (time) => {
          if (time > new Date()) {
            return true;
          }
          return false;
        },
      },
    };
  },
  computed: {
    // 认证状态
    authStatus() {
      return this.$store.state.authStatus;
    },
  },
  created() {
    this.getDepartList();
    this.getAllRole();
    this.init();
  },
  methods: {
    // 添加授权关系
    addQuickBind() {
      this.$router.push({ name: 'staffQuickBind' });
    },
    // 创建企业员工
    createNew() {
      // 未认证情况下，禁止使用功能
      if (this.authStatus !== 3) {
        this.$message.error('企业主体未认证');
        return;
      }

      this.isCreate = true;
      this.editorEmployeeId = null;
      this.canEditor = true;
    },
    // 关闭新建员工
    closeCreate(isInit) {
      this.isCreate = false;
      this.editorEmployeeId = null;
      this.canEditor = true;
      if (isInit) {
        this.getDepartList(true);
        this.init(this.pageNum);
      }
    },
    async getDepartList(reload) {
      try {
        const { code, data } = await getDepartList();
        if (code === 200) {
          const { content, deptTenantItem, unallocatedDeptInfo } = data;
          const departments = treeBuild({
            nodes: content,
            idKey: 'deptId',
            pidKey: 'parentId',
            rootId: 0,
          });
          // 企业id与部门id可能重合
          deptTenantItem.tenantId = `qiye-${deptTenantItem.tenantId}`;
          this.departments = departments;
          this.departmentsArr = content;
          this.departmentTree = [
            {
              deptId: deptTenantItem.tenantId,
              deptName: deptTenantItem.tenantName,
              ...deptTenantItem,
              children: [
                ...departments,
                unallocatedDeptInfo,
              ],
            },
          ];
          this.company = deptTenantItem;
          if (!reload) {
            this.treeDefaultExpendedKeys = [deptTenantItem.tenantId];
            this.currentDeptId = deptTenantItem.tenantId;
          }
          this.$nextTick(() => {
            if (this.$refs.tree) {
              this.$refs.tree.setCurrentKey(reload ? this.currentDeptId : deptTenantItem.tenantId);
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleDepartClick(nodeObj) {
      this.currentDeptId = nodeObj.deptId;
      this.search();
    },
    async getAllRole() {
      const { code, data, message } = await getAllRole();

      if (code === 200) {
        this.roleList = [
          {
            roleId: null,
            roleName: '全部',
          },
        ].concat(data.content || []);
      } else {
        this.$message.error(message || '角色列表获取失败');
      }
    },
    // 获取员工列表
    async getList() {
      this.loading = true;
      let hasSearchItem = false;
      const params = {};
      Object.keys(this.searchForm).forEach((item) => {
        if (this.searchForm[item] !== null && this.searchForm[item] !== '') {
          params[item] = this.searchForm[item];
          hasSearchItem = this.searchForm[item] ? true : hasSearchItem;
        }
      });
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      if (this.company.tenantId && this.currentDeptId !== this.company.tenantId) {
        params.deptId = this.currentDeptId;
      }
      this.emptyText = hasSearchItem ? '暂无数据' : '暂无员工数据，请点击右上角创建员工';
      const res = await employeeList(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = false;
      if (code === 200) {
        this.list = data.content || [];
        this.pageSize = Number(data.pageSize);
        this.pageNum = Number(data.pageNo);
        this.total = Number(data.totalNumber);
        this.loading = false;
      } else {
        this.$message.error(message || '获取员工列表失败！');
      }
    },
    // 账号授权
    bind(employeeId) {
      this.$router.push({ name: 'staffBind', query: { id: employeeId } });
    },
    bindAuth(employeeId) {
      this.$router.push({
        name: 'staffAuth',
        query: {
          id: employeeId,
        },
      });
    },
    // 获取真实电话号码
    async getRealPhone(employeeId) {
      const res = await employeeInfo({ id: employeeId });
      const {
        code, data, message,
      } = res;
      if (code !== 200) {
        this.$message.error(message || '获取员工基础信息失败！');
      }
      return data.phone || null;
    },
    // 邀请
    async invite(item) {
      const { name, phone, employeeId } = item;
      if (!phone) {
        this.$message({
          message: '该员工暂无手机号，请先完善信息！',
          type: 'warning',
        });
        return;
      }
      const realPhone = await this.getRealPhone(employeeId);
      const confirmText = ['请确认手机号是否准确，并提醒员工收到短信后，根据短信提示进行操作。', `员工姓名：${name}`, `手机号码：${realPhone}`];
      const newDatas = [];
      const h = this.$createElement;
      confirmText.forEach((text) => {
        newDatas.push(h('p', null, text));
      });
      this.$confirm(h('div', null, newDatas), '', {
        confirmButtonText: '发送短信邀请',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          clstagA('pageclick|keycount|staff_list|op_invite_sendMsg');
          const res = await employeeInvite({ employeeId });
          const {
            // eslint-disable-next-line no-unused-vars
            code, data, message, subErrors,
          } = res;
          if (code === 200) {
            this.$message({
              message: '发送邀请成功！',
              type: 'success',
              onClose: () => {
                // this.init();
              },
            });
          } else {
            this.$message.error(message || '发送邀请失败，请稍后重试！');
          }
        })
        .catch(() => {
          clstagA('pageclick|keycount|staff_list|op_invite_cancel');
        });
    },
    // 编辑
    editor(item, canEditor = true) {
      this.isCreate = true;
      this.editorEmployeeId = item.employeeId;
      this.canEditor = canEditor;
    },
    // 停用员工
    remove(item) {
      const confirmText = ['确认此员工离职吗？', '离职后，员工将不能再使用员工账号登录企业中心和管理后台，但店铺账号依然可用', `员工姓名：${item.name}`, `手机号码：${item.phone}`];
      const newDatas = [];
      const h = this.$createElement;
      confirmText.forEach((text) => {
        newDatas.push(h('p', null, text));
      });
      this.$confirm(h('div', null, newDatas), '', {
        confirmButtonText: '离职',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          clstagA('pageclick|keycount|staff_list|op_remove_sure');
          const res = await employeeDelete({ id: item.employeeId });
          const {
            // eslint-disable-next-line no-unused-vars
            code, data, message, subErrors,
          } = res;
          if (code === 200) {
            this.$message({
              message: '离职成功！',
              type: 'success',
            });
            this.init(this.pageNum);
          } else {
            this.$message.error(message || '离职失败请稍后重试！');
          }
        })
        .catch(() => {
          clstagA('pageclick|keycount|staff_list|op_remove_cancel');
        });
    },
    // 启用员工
    enable(item) {
      const confirmText = ['确认此员工入职吗？', `员工姓名：${item.name}`, `手机号码：${item.phone}`];
      const newDatas = [];
      const h = this.$createElement;
      confirmText.forEach((text) => {
        newDatas.push(h('p', null, text));
      });
      this.$confirm(h('div', null, newDatas), '', {
        confirmButtonText: '入职',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          clstagA('pageclick|keycount|staff_list|op_add_cancel');
          const res = await employeeEnable({ id: item.employeeId });
          const {
            // eslint-disable-next-line no-unused-vars
            code, data, message, subErrors,
          } = res;
          if (code === 200) {
            this.$message({
              message: '启用成功！',
              type: 'success',
            });
            this.init(this.pageNum);
          } else {
            this.$message.error(message || '启用失败请稍后重试！');
          }
        })
        .catch(() => {
          clstagA('pageclick|keycount|staff_list|op_add_cancel');
        });
    },
    changePageSize(val) {
      this.loading = true;
      this.pageSize = val;
      this.pageNum = 1;
      this.getList();
    },
    changeCurrentPage(val) {
      this.loading = true;
      this.pageNum = val;
      this.getList();
    },
    // 查询
    search() {
      const { phone, email } = this.searchForm;
      const phoneReg = /^(0086)?1\d{10}$/;
      if (phone && !phoneReg.test(phone)) {
        this.searchForm.phone = '';
        this.$message.error('请输入正确的手机号');
      }

      // eslint-disable-next-line no-useless-escape
      const emailReg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/;
      if (email && emailReg.test(email) === false) {
        this.searchForm.businessId = '';
        this.$message.error('请输入正确的邮箱地址');
        return;
      }

      this.init();
    },
    // 重置
    reset() {
      this.searchForm = {
        name: '',
        gender: null,
        email: '',
        phone: '',
        status: null,
        createTime: '',
      };
      this.$refs.listFrom.resetFields();
      this.init();
    },
    // 初始化
    init(pageNum = 1) {
      this.pageNum = pageNum;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-list {
  padding: 30px 20px 106px;
  width: 100%;
  box-sizing: border-box;
  .top-box {
    width: 100%;
    line-height: 36px;

    .big-title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }

    .use-help {
      margin-right: 20px;
      font-size: 12px;
      color: #5199f7;
      cursor: pointer;
    }
  }
  .desc {
    margin-top: 5px;
    font-size: 12px;
    line-height: 17px;
    color: #9ca7b5;
  }
  .search-list {
    .w238 {
      width: 238px;
    }
    .search-item:nth-child(2n) {
      margin-right: 0px;
    }
    .search-item {
      margin-bottom: 10px;
      label {
        padding: 0 10px 0 0;
        color: #464c5b;
      }
    }
  }

  .search-btn-box {
    padding-top: 10px;
    text-align: center;
  }

  .staff-container {
    display: flex;
    margin-top: 20px;
  }

  .staff-department-tree {
    flex-shrink: 0;
    width: 244px;
    padding: 0 15px 0 0;
    border-right: 1px solid rgba(0, 0, 0, 0.09);

    .staff-department-tree-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }

    .staff-department-tree-title {
      color: rgba(0,0,0,0.85);
      font-weight: 500;
      font-size: 14px;
      line-height: 30px;
    }
  }

  ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background: transparent;

    .el-tree-node__label {
      color: #4D80F0;
    }
  }
  ::v-deep .el-tree-node__content:hover {
    cursor: pointer;
  }
  ::v-deep .el-tree-node__label {
    width: calc(100% - 20px);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .staff-list-body {
    // 写死宽度，不依托 flex 计算，宽度会自动被内容撑开
    width: 740px;
    padding-left: 20px;
    box-sizing: border-box;
  }

  .list-table {
    margin-top: 30px;
    margin-bottom: 10px;
    width: 100%;
    background: #ffffff;
    border-bottom: none;
    font-size: 12px;
    color: #464c5b;
    line-height: 17px;
    .green {
      color: #34D19D;
    }
    .red {
      color: #FA4350;
    }
    .status-icon {
      display: inline-block;
      margin-left: 6px;
      color: #9ca7b6;
    }
  }
}
</style>
